import { batch } from 'react-redux'
import { errorTypes } from 'universal'
import { sessionExpired, requestBlocked } from '../../../actions/common'
import { hideMainPageSpinner, hideModalPageSpinner } from '@/features/ui/ui-slice'
import { goToMyAccount, goToCardManagementFlow } from 'utils/navigate'
import { isDev, hasFeature } from 'utils/server-data'
import { getQueryParam } from 'utils/query'
import { getFetchState } from 'utils/flow'
import { productNames } from 'universal/cfs-card'

const {
  REQUEST_CANCELLED_ERROR,
  UNAUTHORIZED_ERROR,
  FORBIDDEN_ERROR,
  UNEXPECTED_RUNTIME_ERROR,
  REQUEST_BLOCKED_ERROR,
  NOT_FOUND_ERROR,
} = errorTypes

function errorHandler() {
  /**
   * Central error handler for common errors
   */
  return (store) => (next) => (action) => {
    const { dispatch, getState } = store || {}

    try {
      // Note getState can also be passed along with dispatch
      const { error: v2Error, fetchName } = action?.payload || {}
      const error = action.fetchError || v2Error
      if (error) {
        const { isFromMainPage } = getFetchState(getState(), fetchName) || {}
        // eslint-disable-next-line default-case
        switch (error.type) {
          case REQUEST_CANCELLED_ERROR:
            // do nothing
            return

          case UNAUTHORIZED_ERROR:
            batch(() => {
              if (isFromMainPage) {
                dispatch(hideMainPageSpinner())
              } else {
                dispatch(hideModalPageSpinner())
              }

              // v1 state, state.common.sessionExpired  to support both v1 and v2 flows
              dispatch(sessionExpired(error.login_url))
            })
            return

          case FORBIDDEN_ERROR:
            // TODO Ask user to reload the page and try again
            break

          case UNEXPECTED_RUNTIME_ERROR:
            // TODO Display common error message
            break

          case REQUEST_BLOCKED_ERROR:
            batch(() => {
              if (isFromMainPage) {
                dispatch(hideMainPageSpinner())
              } else {
                dispatch(hideModalPageSpinner())
              }
              dispatch(requestBlocked(error.actionType))
            })
            return

          case NOT_FOUND_ERROR:
            // TODO To confirm if we are to redirect or
            // display page not found
            // dispatch(notFound())
            if (hasFeature('enableManageCard')) {
              const productName = getQueryParam('productName') || productNames.CONSUMER_DEBIT_CARD
              goToCardManagementFlow({ productName })
              return
            }
            goToMyAccount()
            return
        }
      }

      next(action)
      return
    } catch (err) {
      if (isDev()) {
        // eslint-disable-next-line no-console
        console.error(`Redux middeware - ${errorHandler.name}, unexpected error:`, err)
      }
      throw err
    }
  }
}

export { errorHandler }
